// 2026-07-01 - FormuLearning - 프론트 오퍼레이션 이벤트 기록 (이슈 #32)
// 파일 위치: frontend/src/api/operations.ts
// 백엔드 진입점이 없는 오퍼레이션(RLD 비교·명시적 저장·프로젝트 로드)을 서버에 기록.
// best-effort — 실패해도 사용자 동작을 막지 않는다.

import client from './client'

export function recordOperation(operation: string, projectId?: string, meta?: Record<string, unknown>): void {
  client.post('/operations', { operation, project_id: projectId ?? null, meta: meta ?? null })
    .catch(() => { /* 계측 실패 무시 */ })
}
